/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import React from 'react';
import { useSelector } from 'react-redux';
import PageHeader from '../../component/Common/PageHeader/PageHeader';
import { ButtonContainer } from '../Users/Users.style';
import ButtonComp from '../../component/Common/Button/Button.view';
import PaginationWithPage from '../../component/Common/Pagination/PaginationWithPage.view';

const ProfileHeader = (props) => {
  const {
    title,
    hasBack,
    isFormEditable,
    isCreate,
    handleProfileEdit,
    handleProfileCreate,
    handleSave,
    handleCancel,
    handleBack,
    children,
    pageSize = 10,
    profileCount = 0,
    handlePageChange = () => {},
    isSaveEnabled,
    canAdd = 0,
    canEdit
  } = props;
  const { searchQueries } = useSelector((state) => state.profileDetails);

  return (
    <>
      <PageHeader hasBack={hasBack} handleBack={handleBack} title={title}>
        {!isFormEditable ? (
          <ButtonContainer>
            {isCreate
              ? canAdd && (
                  <ButtonComp onClick={handleProfileCreate}>
                    Add Spare
                  </ButtonComp>
                )
              : canEdit && (
                  <ButtonComp onClick={handleProfileEdit}>Edit</ButtonComp>
                )}
            <PaginationWithPage
              ItemsPerPage={pageSize}
              total={profileCount}
              handlePageChange={handlePageChange}
              searchParams={searchQueries}
            />
          </ButtonContainer>
        ) : (
          <ButtonContainer>
            <ButtonComp onClick={handleCancel}>Cancel</ButtonComp>
            <ButtonComp disabled={!isSaveEnabled} dark onClick={handleSave}>
              Save
            </ButtonComp>
          </ButtonContainer>
        )}
        {children}
      </PageHeader>
    </>
  );
};

export default ProfileHeader;
